import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default, { useState } from 'react';
import styled, { withTheme } from 'styled-components';
import Text from '../text/text.component.js';
import '../buttons/button.component.js';
import Action from '../actions/action.component.js';
import '../wrapper/wrapper.component.js';
import '../../App.css.js';
var _excluded = ["style", "width", "height", "selected", "icon", "small", "titleText", "captionText", "linkText", "LinkComponent", "link", "linkIcon", "theme", "comingSoon", "hoverEnabled", "className", "linkColorHover"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
styled.img.withConfig({
  displayName: "landing-cardcomponent__Icon",
  componentId: "sc-wos0qk-0"
})(["width:10px;height:15px;object-fit:contain;margin-right:15px;"]);
var LinkDiv = styled.div.withConfig({
  displayName: "landing-cardcomponent__LinkDiv",
  componentId: "sc-wos0qk-1"
})([""]);
var Div = styled.div.withConfig({
  displayName: "landing-cardcomponent__Div",
  componentId: "sc-wos0qk-2"
})(["padding-top:34px;padding-left:34px;padding-right:34px;padding-bottom:34px;border-radius:34px;background-color:unset;.text-link-card{color:var(--green) !important;}@media screen and (max-width:768px){.card-icon{margin-bottom:24px !important;}padding-top:34px;padding-left:24px;padding-right:24px;padding-bottom:34px;border-radius:24px;}", ""], function (props) {
  return props.hoverEnabled ? "&:hover {\n      background-color: var(--green) !important;\n      cursor: pointer;\n      transition: 0.2s;\n\n\n      .title-card {\n        color: var(--white)!important;\n      }\n\n      .description-card {\n        color: var(--white)!important;\n      }\n    }" : props.link ? "&:hover {\n      cursor: pointer;\n    }" : "";
});
styled(Text).withConfig({
  displayName: "landing-cardcomponent__TextLink",
  componentId: "sc-wos0qk-3"
})(["@media screen and (max-width:768px){font-family:EuclidCircularA-Bold,Arial;font-weight:700;font-size:16px;line-height:20px;}"]);
var LandingCard = function LandingCard(_ref) {
  var style = _ref.style,
    width = _ref.width;
  _ref.height;
  _ref.selected;
  var icon = _ref.icon,
    small = _ref.small,
    titleText = _ref.titleText,
    captionText = _ref.captionText,
    linkText = _ref.linkText,
    LinkComponent = _ref.LinkComponent,
    link = _ref.link,
    linkIcon = _ref.linkIcon,
    theme = _ref.theme,
    comingSoon = _ref.comingSoon,
    hoverEnabled = _ref.hoverEnabled,
    className = _ref.className,
    linkColorHover = _ref.linkColorHover,
    rest = _objectWithoutProperties(_ref, _excluded);
  var LinkObj = link && LinkComponent ? LinkComponent : LinkDiv;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    forceHover = _useState2[0],
    setForceHover = _useState2[1];
  return /*#__PURE__*/React__default.createElement(Div, _extends({
    className: "link-card " + className,
    hoverEnabled: (!comingSoon && link || hoverEnabled) && !(hoverEnabled == false),
    link: link,
    onMouseOver: function onMouseOver() {
      setForceHover(true);
    },
    onMouseOut: function onMouseOut() {
      setForceHover(false);
    },
    style: _objectSpread({
      width: width,
      display: "flex",
      boxSizing: "border-box",
      flexDirection: "column",
      alignItems: "start"
    }, style)
  }, rest), /*#__PURE__*/React__default.createElement(LinkObj, {
    to: link ? link : "unset",
    title: titleText,
    target: link && link.includes("http") ? "_blank" : "_self",
    style: {
      height: "100%",
      display: "flex",
      boxSizing: "border-box",
      flexDirection: "column",
      alignItems: "start",
      textDecoration: "none",
      cursor: comingSoon ? "default" : "inherit",
      pointerEvents: comingSoon ? "none" : "auto"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: "100%",
      display: "flex",
      boxSizing: "border-box",
      flexDirection: "column",
      alignItems: "start"
    }
  }, icon ? /*#__PURE__*/React__default.createElement("img", {
    src: icon,
    alt: "icon",
    className: "card-icon",
    style: {
      marginBottom: "34px"
    }
  }) : null, /*#__PURE__*/React__default.createElement(Text, {
    className: "title-card",
    fontFamily: "euclid",
    tag: "h3",
    type: small ? "label" : "heading",
    fontSize: small ? "xxlarge" : "xlarge",
    style: {
      marginBottom: "0px",
      textAlign: "left"
    }
  }, titleText), /*#__PURE__*/React__default.createElement(Text, {
    className: "description-card",
    fontFamily: "euclid",
    type: "paragraph",
    fontSize: "largeM",
    color: theme.layout == "dark" ? "var(--dark-gray-1)" : "var(--light-gray-1)",
    style: {
      marginTop: small ? "24px" : "34px",
      textAlign: "left"
    }
  }, captionText), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "auto",
      paddingTop: "34px",
      maxHeight: "39px",
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(Action, {
    linkText: linkText,
    color: "green",
    colorHover: hoverEnabled ? linkColorHover ? linkColorHover : "default" : "",
    active: !comingSoon,
    linkIcon: linkIcon,
    forceHover: forceHover,
    moveIcon: true
  })))));
};
LandingCard.defaultProps = {
  hoverEnabled: true
};
var landingCard_component = withTheme(LandingCard);
export { landingCard_component as default };